import 'aliceonboarding/dist/aliceonboarding.css';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CONFIG } from 'config/config';
import routes from 'config/config/routes';
import { isIOS, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	Button,
	IdentityDocumentsWrapper,
	NavigationWrapper,
	PickerHOC,
	TargetsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import { MainModal } from 'components/MainModal/MainModal';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { DebugContext } from '../../App';
import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import { aliceOnError } from './hooks/aliceOnError';

//import IframeResizer from 'iframe-resizer-react';

export const IdentityBiometric = PickerHOC({
	dniData: {
		arrayItemMatcher: {
			type: 'value',
			itemPropertyPath: 'main',
			value: true,
		},
		sourcePath: 'identityDocuments',
		sourceWrapper: IdentityDocumentsWrapper,
	},
	target: {
		sourceWrapper: TargetsWrapper,
		sourcePath: 'targets',
		arrayItemMatcher: {
			type: 'param',
			paramName: 'targetId',
			itemPropertyPath: 'id',
		},
	},
	user: {
		sourcePath: 'user',
		sourceWrapper: UserWrapper,
	},
})(() => {
	const baseUrl = window.location.origin;
	const { dniData, user, target } = PickerHOC.use();
	const { useHeader, useFooter, openModal, useLoading } = UiWrapper.use();
	const { navigateTo, location, goBack, query } = NavigationWrapper.use();
	const { updateUser } = UserWrapper.use();
	const { t, i18n } = useTranslation();
	const isDebug = React.useContext(DebugContext);
	const { loadUserIdentityDocuments } = IdentityDocumentsWrapper.use();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('IdentityBiometric');

	console.log('👉 dniData', dniData);

	const pendingFlow = useMemo(
		() =>
			dniData.verificationStatus === 'NOT_CREATED' ||
			dniData.verificationStatus === 'PENDING',
		[dniData],
	);
	const successFlow = useMemo(() => dniData.verificationStatus === 'VALID', [dniData]);
	const errorFlow = useMemo(() => dniData.verificationStatus === 'NOT_VALID', [dniData]);

	const [scannedDNI, setscannedDNI] = useState('');
	const [sameBenefDNI, setsameBenefDNI] = useState(false);
	const [diferentToReceived, setdiferentToReceived] = useState(false);

	console.log('🚩 scannedDNI', scannedDNI);
	console.log('🚩 sameBenefDNI', sameBenefDNI);
	console.log('🚩 diferentToReceived', diferentToReceived);

	// IDENTITY MOCK
	const esMock = window?.__CLIENT_ENV?.CLIENT_ENV_IDENTITY_MOCK === 'true' ?? false;

	useEffect(() => {
		const reviewSuccess = async () => {
			// Respuesta OK, continuamos con lo que venga
			const scannedDNIeffect = dniData?.number;
			setscannedDNI(scannedDNIeffect);

			console.log('target?.creationData', target?.creationData);

			const sameBenefDNIeffect =
				target?.creationData?.details?.beneficiaryType !== 'generico' &&
				target?.creationData?.details?.beneficiaries?.find(
					(be) => be?.dni.toUpperCase() === scannedDNIeffect.toUpperCase(),
				);
			setsameBenefDNI(sameBenefDNIeffect ? true : false);

			const diferentToReceivedeffect =
				user?.metadata?.document &&
				scannedDNIeffect?.toUpperCase() !== user?.metadata?.document?.toUpperCase();
			setdiferentToReceived(diferentToReceivedeffect ? true : false);

			if (sameBenefDNIeffect) {
				const userPayload = {
					...user,
					metadata: {
						...user?.metadata,
						identityBiometricError: 'sameBeneficiary',
					},
				};
				await updateUser(userPayload);
			} else if (diferentToReceivedeffect) {
				const userPayload = {
					...user,
					metadata: {
						...user?.metadata,
						identityBiometricError: 'diferentToInitial',
					},
				};
				await updateUser(userPayload);
			} else {
				CONFIG.routing.identityBiometric.next(navigateTo);
			}
		};
		if (successFlow) {
			reviewSuccess();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [successFlow]);

	const intervalTime = 5000; // Tiempo en milisegundos (3 segundo)
	useEffect(() => {
		if (!pendingFlow) return; // Si ya se alcanzó el valor, no hacer nada

		const interval = setInterval(() => {
			console.log('🎯 loadUserIdentityDocuments');
			loadUserIdentityDocuments(user.id);
		}, intervalTime);

		return () => clearInterval(interval); // Limpia el intervalo cuando cambie la dependencia

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dniData.verificationStatus]);

	// TARGET CREATION DATA
	const creationData = useMemo(
		() => target?.targetProperties?.find((x) => x.name === 'creationData')?.value,
		[target],
	);

	// ESTADO
	const scanManaggerReference = useRef();

	const issuingCountry = useMemo(
		() => user?.metadata?.documentCountryIDS?.toUpperCase() || 'ESP',
		[user],
	);
	const currentLang = useMemo(() => 'es', []);
	const enableSelfie = useMemo(() => (query?.selfie === 'false' ? false : true), [query]);

	// NAVIGATION
	const nextPath = useMemo(
		() =>
			location.pathname.slice(0, location.pathname.lastIndexOf('/')) +
			`/IdentityBiometricFinished`,
		[location.pathname],
	);

	// EFFECTS
	useEffect(() => {
		console.log('📌 nextPath', `${baseUrl}${nextPath}`);
		console.log('📌 user', user);
		console.log('📌 creationData', creationData);
		console.log('📌 dniData', dniData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper
			showTopSection
			step={3}
			title="Documento de identidad"
			subtitle="Por favor, sigue las indicaciones que se te muestran en la pantalla."
		>
			<View
				innerWrapperSt
				style={{
					minHeight: !isMobile ? 770 : undefined,
					alignItems: 'center',
				}}
			>
				{esMock && (
					<IdentityDocumentsWrapper.ScanManager
						ref={scanManaggerReference}
						style={{
							marginTop: 30,
							width: '100%',
							height: isMobile ? '670px' : '100%',
							overflow: 'hidden',
						}}
						identityDocumentId={dniData?.id}
						mockEnabled={true}
						scanConfig={{
							/**
							 * mock user
							 */
							providerIdentifier: 'mock',
							additionalStages: ['selfie'],
							completeTimeout: 500,
							// Custom "Scan" dependant parameters (for this case is Alice)
							metadata: {},
						}}
						onSuccess={async (data) => {
							// Respuesta OK, continuamos con lo que venga
							const aliceDNI = data?.value?.data?.report?.documents[0]?.summary_fields?.find(
								(sf) => sf?.name === 'id_number',
							)?.value;
							const sameBenefDNI = target?.creationData?.details?.beneficiaries?.find(
								(be) => be?.dni.toUpperCase() === aliceDNI.toUpperCase(),
							);
							const diferentToReceived = false;

							if (sameBenefDNI) {
								const userPayload = {
									...user,
									metadata: {
										...user?.metadata,
										identityBiometricError: 'sameBeneficiary',
									},
								};
								await updateUser(userPayload);
								openModal(
									(close) => (
										<MainModal type="error">
											<Text headingPrimarySt errorSt>
												Se ha encontrado un error en el listado de
												beneficiarios
											</Text>
											<Text headingTertiarySt errorSt>
												No puedes añadirte tú mismo como beneficiario
											</Text>
											<Button
												style={{
													marginTop: 30,
												}}
												onClick={() => {
													close();
													CONFIG.routing.identityBiometric.modifyBenef(
														navigateTo,
													);
												}}
											>
												Modificar
											</Button>
										</MainModal>
									),
									{
										executeOnClose: () => {
											CONFIG.routing.identityBiometric.modifyBenef(
												navigateTo,
											);
										},
										disableClickAway: true,
										closeButton: true,
										modalClass: isMobile ? 'modal-xl' : 'modal-main',
										key: 'modal-alice-sameBenef',
									},
								);
							} else if (diferentToReceived) {
								const userPayload = {
									...user,
									metadata: {
										...user?.metadata,
										identityBiometricError: 'diferentToInitial',
									},
								};
								await updateUser(userPayload);
								openModal(
									(close) => (
										<MainModal>
											<Text headingPrimarySt errorSt>
												Se ha encontrado un error en el documento añadido
											</Text>
											<Text headingTertiarySt errorSt>
												El número del documento escaneado no coincide con el
												que se indicó al inicio del proceso.
											</Text>

											{isDebug && (
												<Text headingTertiarySt errorSt>
													aliceDNI → {aliceDNI} | initialDNI →
													{user?.metadata?.document}
												</Text>
											)}
											<Button
												style={{ marginTop: 30, marginBottom: 0 }}
												onClick={() => {
													close();
													CONFIG.routing.identityBiometric.modifyDNI(
														navigateTo,
													);
												}}
											>
												Modificar
											</Button>
										</MainModal>
									),
									{
										disableClickAway: true,
										closeButton: true,
										modalClass: isMobile ? 'modal-xl' : 'modal-main',
										key: 'modal-alice-diferent',
									},
								);
							} else {
								CONFIG.routing.identityBiometric.next(navigateTo);
							}
						}}
						onFailure={(data) => {
							aliceOnError(data, openModal, navigateTo, scanManaggerReference);
						}}
						onCancel={(data) => {
							console.log('💥 onCancel mock data', data);
							navigateTo(routes.clientData, { queryParams: { internalStep: 4 } });
						}}
					/>
				)}
				{!esMock && pendingFlow && (
					<IdentityDocumentsWrapper.SimpleScanManager
						ref={scanManaggerReference}
						identityDocumentId={dniData?.id}
						style={{
							marginTop: 30,
							width: '100%',
							height: isMobile ? '670px' : '500px',
							overflow: 'hidden',
						}}
						scanConfig={{
							providerIdentifier: 'tecalis',
							metadata: {
								kyc: {
									excludedDocTypes: [],
									allowedDocTypes: [
										`${issuingCountry}_DNI`,
										`${issuingCountry}_NIE`,
										`PASSPORT_${issuingCountry}`,
									],
									status_report: ['Verification OK'],
									methods: {
										ReadMrz: true,
										VerifyData: true,
										Images: true,
										Liveness: enableSelfie,
										FaceMatch: enableSelfie,
										FacialRecognition: enableSelfie,
										Selfie: false,
										FraudScoring: true,
										ImagesUrl: false,
										StorageUpload: true,
										Otp: true,
										Location: true,
										CheckFacesNumber: true,
									},
									fraudScoring: {
										aeat: true,
										expirationDate: true,
										legalAge: true,
										photocopyCheck: true,
										hologramCheck: false,
									},
								},
								front: {
									iframe_mode: true,
									kyc_mode: 'auto',
									liveness_guidance_mode: 'smile',
									skin: 'light',
									borders: true,
									borders_percentage: 50,
									borders_width: 50,
									video_mode: 'native',
									css_url: false,
									wait_after_kyc_success: true,
									'no-spinner': false,
									title_kyc: 'Documento de identidad',
									mirror_mode_pc: true,
									location_config: 'optional',
									default_lang: currentLang,
									force_lang: currentLang,
									accept_manual_text: '',
									new_index: false,
									iccid: false,
									msisdn: false,
									barcode_min: false,
									auditoria: true,
									headless_barcode: false,
									prioridad_interrupcion: 'postergado',
									final_imprimible: false,
									adapt_detector_to_passport: true,
									retries_before_manual_pc: 3,
									retries_before_manual_others: 3,
									logs: false,
								},
							},
						}}
					/>
				)}
				{!esMock && sameBenefDNI && (
					<View
						style={{
							marginTop: !isMobile ? 40 : 20,
							maxWidth: !isMobile ? 600 : undefined,
						}}
					>
						<Text headingPrimarySt errorSt>
							Se ha encontrado un error en el listado de beneficiarios.
						</Text>
						<Text headingTertiarySt errorSt>
							No puedes añadirte tú mismo como beneficiario.
						</Text>
						<Button
							style={{
								marginTop: 30,
							}}
							onClick={() => {
								CONFIG.routing.identityBiometric.modifyBenef(navigateTo);
							}}
						>
							Modificar
						</Button>
					</View>
				)}
				{!esMock && diferentToReceived && (
					<View
						style={{
							marginTop: !isMobile ? 40 : 20,
							maxWidth: !isMobile ? 600 : undefined,
						}}
					>
						<Text headingPrimarySt errorSt>
							Se ha encontrado un error en el documento añadido.
						</Text>
						<Text headingTertiarySt errorSt>
							El número del documento escaneado no coincide con el que se indicó al
							inicio del proceso.
						</Text>

						{isDebug && (
							<Text headingTertiarySt errorSt>
								scannedDNI → {scannedDNI} | initialDNI →{user?.metadata?.document}
							</Text>
						)}
						<Button
							style={{ marginTop: 30, marginBottom: 0 }}
							onClick={() => {
								CONFIG.routing.identityBiometric.modifyDNI(navigateTo);
							}}
						>
							Modificar
						</Button>
					</View>
				)}
				{!esMock && errorFlow && (
					<>
						<Text headingPrimarySt errorSt>
							❌ Proceso terminado con error
						</Text>
						<Button
							style={{ marginTop: 30, marginBottom: 0 }}
							onClick={() => {
								CONFIG.routing.identityBiometric.back(goBack);
							}}
						>
							Reintentar
						</Button>
					</>
				)}
			</View>
			<BackNextButton
				onClickBack={() => navigateTo(routes.identityBiometricSteps)}
				isNextShown={false}
			/>
		</Wrapper>
	);
});
